import crypto from 'crypto';
function Md5(str) {
    return crypto.createHash('md5').update(str).digest('hex');
}

// axios
import $http from '@/api';
import Axios from 'axios'

// 请求 又拍云 上传文件的 地址
const upyunHost = 'https://v0.api.upyun.com';
// 显示又拍云 图片的 前缀
const upyun_domin = 'http://upyun.yuximi.com';

// 设置默认参数
const bucket = 'image-yuximi';
// const operator = 'pengdashu';
// 获取签名的 地址
const getSignatureUrl = 'get_upyun_signature';


/**
 * 
 * @param {!File} file 需要上传的文件
 * @param {!String} remotePath 上传文件需要保存的路径
 */
async function upload(file, remotePath) {
    // 获取 文件 路径及名称
    let local_name = file.name;
    let file_name = local_name.substr(0, local_name.lastIndexOf('.'));
    file_name = randomString(file_name);
    let file_type = local_name.substr(local_name.lastIndexOf('.'), local_name.length);
    // 存储路径
    remotePath = `${remotePath}/${dateString()}/${file_name}${file_type}`;
    // 生成 polic
    let date = new Date();
    let opts = {
        'bucket': bucket,
        'save-key': remotePath,
        'expiration': date.getTime() + 1000 * 60 * 60 * 2,
        'content-length': file.size,
        'date': date.toGMTString(),
    }
    let policy = Base64.encode(JSON.stringify(opts));
    // 获取签名
    let signature = await getSignature(policy);
    // 生成 上传参数 formdata
    let formData = new FormData();
    formData.append("policy", policy);
    formData.append("signature", signature);
    formData.append("file", file);
    // 上传文件 并返回结果
    return await Axios({
        url: `${upyunHost}/${bucket}`,
        method: 'post',
        data: formData,
        processData: false,     // 告诉axios不要去处理发送的数据(重要参数)
        contentType: false,     // 告诉axios不要去设置Content-Type请求头
    });
}

/**
 * 获取 签名 signature
 * @param {!String} policy // 经过 base64的
 */
async function getSignature(policy) {
    // js 本地 生成 signature
    // let api_secret = "3Hb6YAWbUxSsbwm1VOXQ3H7Q3pA=";
    // let signature = Md5(`${policy}&${api_secret}`);
    // return signature;

    // 请求 后端加密的 signature
    let signature = await $http({
        url: getSignatureUrl,
        data: {
            policy: policy,
        },
    });
    return signature.data.signature;
}

/* eslint-disable */
const Base64 = {
    // private property
    _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    // public method for encoding
    encode: function (input) {
        let output = ''
        let chr1, chr2, chr3, enc1, enc2, enc3, enc4
        let i = 0
        input = Base64._utf8_encode(input)
        while (i < input.length) {
            chr1 = input.charCodeAt(i++)
            chr2 = input.charCodeAt(i++)
            chr3 = input.charCodeAt(i++)
            enc1 = chr1 >> 2
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
            enc4 = chr3 & 63
            if (isNaN(chr2)) {
                enc3 = enc4 = 64
            } else if (isNaN(chr3)) {
                enc4 = 64
            }
            output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
        }
        return output
    },
    // public method for decoding
    decode: function (input) {
        let output = ''
        let chr1, chr2, chr3
        let enc1, enc2, enc3, enc4
        let i = 0
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '')
        while (i < input.length) {
            enc1 = this._keyStr.indexOf(input.charAt(i++))
            enc2 = this._keyStr.indexOf(input.charAt(i++))
            enc3 = this._keyStr.indexOf(input.charAt(i++))
            enc4 = this._keyStr.indexOf(input.charAt(i++))
            chr1 = (enc1 << 2) | (enc2 >> 4)
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
            chr3 = ((enc3 & 3) << 6) | enc4
            output = output + String.fromCharCode(chr1)
            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2)
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3)
            }
        }
        output = Base64._utf8_decode(output)
        return output
    },
    // private method for UTF-8 encoding
    _utf8_encode: function (string) {
        string = string.replace(/\r\n/g, '\n')
        let utftext = ''
        for (let n = 0; n < string.length; n++) {
            let c = string.charCodeAt(n)
            if (c < 128) {
                utftext += String.fromCharCode(c)
            } else if ((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192)
                utftext += String.fromCharCode((c & 63) | 128)
            } else {
                utftext += String.fromCharCode((c >> 12) | 224)
                utftext += String.fromCharCode(((c >> 6) & 63) | 128)
                utftext += String.fromCharCode((c & 63) | 128)
            }
        }
        return utftext
    },
    // private method for UTF-8 decoding
    _utf8_decode: function (utftext) {
        let string = ''
        let i = 0
        let c = c1 = c2 = 0
        while (i < utftext.length) {
            c = utftext.charCodeAt(i)
            if (c < 128) {
                string += String.fromCharCode(c)
                i++
            } else if ((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i + 1)
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
                i += 2
            } else {
                c2 = utftext.charCodeAt(i + 1)
                c3 = utftext.charCodeAt(i + 2)
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
                i += 3
            }
        }
        return string
    }
}


/**
 * 当天日期 转字符串
 */
function dateString() {
    var date = '';

    let myDate = new Date();
    let year = myDate.getFullYear().toString();
    let month = (myDate.getMonth() + 1).toString();
    month = month.length < 2 ? '0' + month : month;
    let day = myDate.getDate().toString();
    day = day.length < 2 ? '0' + day : day;

    date = year + month + day;
    return date;
}
/**
 * 生成 随机字符串
 * 
 * @param {String} file_name; 文件名称； 
 */
function randomString(file_name) {
    let date = new Date().getTime();
    let str = "ABCDEFGHJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let random = "";
    for (var i = 0; i < 32; i++) {
        random += str.charAt(Math.floor(Math.random() * str.length));
    }
    return Md5(random + file_name + date);
}
/**
 * 清除 input 的文件
 * @param {!Dom} dom 
 */
function clearInputFile(dom) {
    if (dom.value) {
        try {
            dom.value = ''; //for IE11, latest Chrome/Firefox/Opera... 
        } catch (err) {
            throw(err);
        }
        if (dom.value) { //for IE5 ~ IE10 
            let form = document.createElement('form'),
                ref = dom.nextSibling,
                p = dom.parentNode;
            form.appendChild(f);
            form.reset();
            p.insertBefore(f, ref);
        }
    }
}
/* eslint-enable */



export default {
    upload              : upload,            // 上传文件
    clearInputFile      : clearInputFile,    // 清除 input 的文件
    upyun_domin         : upyun_domin,       // 又拍云文件 前缀
    Base64              : Base64,
    Md5                 : Md5
};